import { useState, useCallback, useEffect } from "react";
import { api } from "@lib/orpc-client";
import * as Sentry from "@sentry/react";

const useFavoriteEWallet = () => {
  const [favorites, setFavorites] = useState<Set<string>>(new Set());

  useEffect(() => {
    api.walletV2.ewallet
      .list({})
      .then((list) => {
        setFavorites(
          new Set(list.filter((e) => e.is_favorite).map((e) => e.uuid))
        );
      })
      .catch(Sentry.captureException);
  }, []);

  const toggleFavorite = useCallback(
    (uuid: string) => {
      const previousFavorites = new Set(favorites);
      const nextFavorites = new Set(favorites);
      const nextValue = !nextFavorites.has(uuid);

      if (nextValue) {
        nextFavorites.add(uuid);
      } else {
        nextFavorites.delete(uuid);
      }

      setFavorites(nextFavorites);

      api.walletV2.ewallet
        .favorite({ uuid, is_favorite: nextValue })
        .catch((err) => {
          setFavorites(previousFavorites);
          Sentry.captureException(err);
        });
    },
    [favorites]
  );

  const isFavorite = useCallback(
    (uuid: string) => favorites.has(uuid),
    [favorites]
  );

  return { isFavorite, toggleFavorite };
};

export default useFavoriteEWallet;
